// language=GraphQL
export const ALL_GRID_BLOCKS_QUERY = `query Query($withColumns: Boolean = false, $withColumnsContentBlockAssignments: Boolean = false, $withColumnsContentBlockAssignmentsBlock: Boolean = false) {
  gridBlocks: cmsGridBlocks {
    id
    columns @include(if: $withColumns) {
      id
      contentBlockAssignments @include(if: $withColumnsContentBlockAssignments) {
        id
        type
        block @include(if: $withColumnsContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_GRID_BLOCK_QUERY = `query Query($id: ID!, $withColumns: Boolean = false, $withColumnsContentBlockAssignments: Boolean = false, $withColumnsContentBlockAssignmentsBlock: Boolean = false) {
  gridBlock: cmsGridBlock(id: $id) {
    id
    columns @include(if: $withColumns) {
      id
      contentBlockAssignments @include(if: $withColumnsContentBlockAssignments) {
        id
        type
        block @include(if: $withColumnsContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_GRID_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsGridBlockInput, $withColumns: Boolean = false, $withColumnsContentBlockAssignments: Boolean = false, $withColumnsContentBlockAssignmentsBlock: Boolean = false) {
    gridBlock: createCmsGridBlock(input: $input) {
      id
      columns @include(if: $withColumns) {
        id
        contentBlockAssignments @include(if: $withColumnsContentBlockAssignments) {
          id
          type
          block @include(if: $withColumnsContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_GRID_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsGridBlockInput, $withColumns: Boolean = false, $withColumnsContentBlockAssignments: Boolean = false, $withColumnsContentBlockAssignmentsBlock: Boolean = false) {
    gridBlock: updateCmsGridBlock(input: $input) {
      id
      columns @include(if: $withColumns) {
        id
        contentBlockAssignments @include(if: $withColumnsContentBlockAssignments) {
          id
          type
          block @include(if: $withColumnsContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_GRID_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsGridBlockInput) {
    deleteCmsGridBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_GRID_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsGridBlockInput) {
    forceDeleteCmsGridBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_GRID_BLOCK_COLUMNS_MUTATION = `
  mutation Mutation($input: addCmsGridBlockColumnsInput) {
    addCmsGridBlockColumns(input: $input) {
      id
      columnIds
    }
  }`

// language=GraphQL
export const REMOVE_GRID_BLOCK_COLUMNS_MUTATION = `
  mutation Mutation($input: removeCmsGridBlockColumnsInput) {
    removeCmsGridBlockColumns(input: $input) {
      id
      columnIds
    }
  }`

// language=GraphQL
export const CREATE_GRID_BLOCK_COLUMNS_MUTATION = `
  mutation Mutation($input: createCmsGridBlockColumnsInput) {
    createCmsGridBlockColumns(input: $input) {
      id
      columnIds
    }
  }`

// language=GraphQL
export const DELETE_GRID_BLOCK_COLUMNS_MUTATION = `
  mutation Mutation($input: deleteCmsGridBlockColumnsInput) {
    deleteCmsGridBlockColumns(input: $input) {
      id
      columnIds
    }
  }`

// language=GraphQL
export const UPDATE_GRID_BLOCK_COLUMNS_ORDER_MUTATION = `
  mutation Mutation($input: updateCmsGridBlockColumnsOrderInput) {
    updateCmsGridBlockColumnsOrder(input: $input) {
      id
      columnIds
    }
  }`
